import { TeamsService } from '@teams/infra';
import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { UpdateTeamBody, UpdateTeamPathParams, UpdateTeamResponse } from '@core-http';
import { CreateTeamCommandPayload } from '../create-team/create-team.command-payload';
import { CreateTeamCommandResult } from '../create-team/create-team.command-result';

export class UpdateTeamCommandHandler {
  private readonly teamsService: TeamsService = inject(TeamsService);

  update(teamId: string, payload: CreateTeamCommandPayload): Observable<CreateTeamCommandResult> {
    const pathParams: UpdateTeamPathParams = { teamId };
    const requestBody: UpdateTeamBody = { teamName: payload.teamName };

    return this.teamsService
      .updateTeam(pathParams, requestBody)
      .pipe(map((dto: UpdateTeamResponse | null) => this.mapToResult(dto, teamId, payload.teamName)));
  }

  private mapToResult(dto: UpdateTeamResponse | null, teamId: string, teamName: string): CreateTeamCommandResult {
    return {
      teamId: dto?.teamId ?? teamId,
      teamName: dto?.teamName ?? teamName,
      invitationToken: dto?.invitationToken ?? ''
    };
  }
}
